import React, {useLayoutEffect, useRef} from 'react';
import {
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
  Box,
  createStyles,
} from '@material-ui/core';
import { TrainersList } from '../../trainers-list/trainers-list';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { ScrollPassWrapper } from '../../../components/scroll-pass-wrapper/scroll-pass.wrapper';

const useStyles = makeStyles(({ breakpoints, spacing }) =>
  createStyles({
    root: {
      margin: spacing(0, 2),
      [breakpoints.up('md')]: {
        margin: spacing(0, 8),
      },
    },
  })
);

export const MeetTrainers = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useStyles();

  const handleSawTheTrainersSection = () => {
    trackCustomEvent({
      category: "Meet Trainers",
      action: "Scroll",
      label: "Saw Meet Trainers Section",
    })
  }



  return (
    <Box className={classes.root} >
      <ScrollPassWrapper onVisible={handleSawTheTrainersSection} >
        <Typography
          color="primary"
          variant={isDesktop ? 'h4' : 'h5'}
          component="h3"
        >
          Meet our coaches!
        </Typography>
      </ScrollPassWrapper>
      <Box mt={4} />
      <TrainersList />
    </Box>
  );
};
